module.exports = __webpack_public_path__ + "img/pencil.8c7b7489.svg";